import React, { useState } from 'react';
import styled from 'styled-components';
import { telemetry } from '../../../@vendor/Posthog';
import { invokeLater } from '../../../CodesThatsGottaGoSomewhereElse';
import { Icon } from '../../../concepts/resources/Icon';
import { Button, Colors, usePrompt } from '../../../ui';
import { DateBadgeButton } from '../../../ui/DateBadgeButton';
import { Popover } from '../../canvas/ui/Popover';
import { SelectUserTableButton } from '../../common/SelectUserTableButton';
import { useResolve } from '../../Container';
import { Flexer, Title } from '../elements/LayoutElements';
import { WorkspaceModel } from '../Models';
import { useOnCreateTask } from './TaskActions';
import { computeTaskDueDateColor, formatTaskDueDate } from './TaskDueDateCell';

const TextArea = styled.textarea`
    resize: none;
    background: #f6f8f9;
    border-radius: .375rem;
    padding: .5rem;
`;

const TaskCreateForm = ({ onClose }: { onClose: () => void }) => {

    const workspace = useResolve(WorkspaceModel);
    const [summary, setSummary] = useState('');
    const [user, setUser] = useState<any>();
    const [dueDate, setDueDate] = useState<any>();
    const [createAnother, setCreateAnother] = useState(false);

    const onCreate = useOnCreateTask(workspace.id, onClose);

    const onSubmit = async () => {
        if (!summary) return;
        const taskId = await onCreate({ summary, userId: user?.id, dueDate });
        telemetry.emit('tasksView.createTask', { taskId });
    };

    const promptRef = usePrompt({
        enterRequiresCtrl: true,
        onAction(confirm) {
            if (!summary) return;
            if (confirm) {
                invokeLater(onSubmit);
            }
            else {
                invokeLater(onClose);
            }
        },
    });

    return <Flexer ref={promptRef} padding="1" width="32">
        <Flexer flex="column" gap="1">
            <Flexer padding=".125">
                <Title color={Colors.text} flush>Create an action</Title>
            </Flexer>
            <TextArea
                autoFocus
                placeholder="Summary..."
                rows={3}
                value={summary}
                onChange={e => setSummary(e.target.value)}
            />

            <Flexer height="2.5" flex="row" align="center" justify="space-between">
                <SelectUserTableButton placeholder="Unassigned" value={user} onChange={setUser} />
                <DateBadgeButton
                    placeholder="No due date"
                    formatter={formatTaskDueDate}
                    color={computeTaskDueDateColor(dueDate)}
                    value={dueDate}
                    onChange={setDueDate} />
            </Flexer>
            <Flexer flex="row" align="center" gap="1">
                <Button variant="primary" disabled={!summary?.trim()} onAction={onSubmit}>Create</Button>
                {/* <Checkbox label="Create Another" checked={createAnother} onChange={setCreateAnother} /> */}
            </Flexer>
        </Flexer>
    </Flexer>;
};

export const TaskCreateButton = () => {
    const [open, setOpen] = useState(false);
    return <Popover
        content={<TaskCreateForm onClose={() => setOpen(false)} />}
        placement="bottom-start"
        inner={{ direction: 'down', offset: '.5' }}
        open={open}
        onOpenChange={setOpen}>
        <Button size="square" variant="frame">
            <Icon size="1.25" src="deqo://icons/deqo/add" />
        </Button>
    </Popover>;
};
